import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const MenuButton = ({ loadingProgress = 0 }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleMenuClick = () => navigate("/menu", { state: { fromStartup: true } });

  const radius = 150;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset =
    circumference - (loadingProgress / 100) * circumference;

  return (
    <Box
      sx={{
        borderRadius: "50%",
        border: "1.5px solid #A1A1AA",
        padding: "30px",
        mb: 6,
        width: "165px",
        height: "165px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        p: 0,
        transition: "transform 0.5s ease-in-out",
        ":hover": {
          transform: "scale(1.05)",
        },
        "::before": {
          content: '""',
          position: "absolute",
          border: "1px solid #D4D4D8",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
        },
        "::after": {
          content: '""',
          position: "absolute",
          border: ".5px solid #E4E4E7",
          width: "230px",
          height: "230px",
          borderRadius: "50%",
        },
      }}
      onClick={handleMenuClick}
    >
      <svg
        width="400px"
        height="400px"
        style={{
          position: "absolute",
          rotate: "-90deg",
        }}
      >
        <circle
          cx="200"
          cy="200"
          r={radius}
          stroke="#E4E4E7"
          strokeWidth="4"
          fill="none"
        />
        <circle
          cx="200"
          cy="200"
          r={radius}
          stroke={theme.palette.primary.main}
          strokeWidth="4"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{
            transition: "stroke-dashoffset 0.3s ease",
          }}
        />
      </svg>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
          position: "relative",
        }}
      >
        <RestaurantMenuIcon
          sx={{
            width: "30px",
            height: "30px",
            color: theme.palette.primary.main,
          }}
        />
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.primary.main,
            mt: 1,
            fontWeight: "bold",
            fontSize: "0.9rem",
            textAlign: "center",
          }}
        >
          Tap to open menu
        </Typography>

        {loadingProgress < 100 && (
          <Box
            sx={{
              position: "absolute",
              bottom: "-30px",
              backgroundColor: theme.palette.primary.main,
              color: "white",
              borderRadius: "20px",
              padding: "4px 12px",
              fontSize: "0.75rem",
              fontWeight: "bold",
              zIndex: 3,
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          >
            {Math.round(loadingProgress)}%
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MenuButton;
